/** Shared display / translation language codes (UI + Google Translate widget). */
export const languageNames: Record<string, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  ru: 'Русский',
  zh: '中文',
  hi: 'हिन्दी',
  ar: 'العربية',
  pt: 'Português',
  ja: '日本語',
  ko: '한국어',
  it: 'Italiano',
  nl: 'Nederlands',
  tr: 'Türkçe',
  pl: 'Polski',
  vi: 'Tiếng Việt',
  th: 'ไทย',
  uk: 'Українська',
  sv: 'Svenska',
  cs: 'Čeština',
};
